
import User from "./UserClass"


const ContactUs=()=>{
  return   (<div className="contactUs">
    <h1>Contact us</h1>
    <button>Hello</button>
   
    </div>)
}
export default ContactUs;